import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ChatContentService } from '../services/chat-content.service';
import { ChatStateService } from '../services/chat-state.service';
import { Subscription, delay, filter, map, take } from 'rxjs';
import { ChatService } from '../services/chat.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-chat-gallery',
  templateUrl: './chat-gallery.component.html',
  styleUrls: ['./chat-gallery.component.scss'],
})
export class ChatGalleryComponent implements OnInit, OnDestroy {
  @ViewChild('scrollContainer')
  public readonly scrollContainer: ElementRef<HTMLElement>;

  public readonly contentInfo$ = this._chatContentService.contentInfo$;
  public readonly chatRating$ = this._chatStateService.aiChatRating$.pipe(
    map((x) => x.rating),
  );

  private _subscriptions: Subscription[] = [];

  constructor(
    private _chatContentService: ChatContentService,
    private _chatStateService: ChatStateService,
    private _modalController: ModalController,
    private _chatService: ChatService,
  ) {}

  public ngOnInit(): void {
    this._subscriptions.push(
      this._chatContentService.contentInfo$
        .pipe(
          filter((res) => !!res?.contents),
          take(1),
          delay(100),
          map((res) =>
            res.contents.find(
              (item) =>
                item.ratingRequired >
                this._chatStateService.aiChatRating$.value.rating,
            ),
          ),
        )
        .subscribe((res) => {
          if (!res) {
            return;
          }
          const photoEl = document.getElementById(`photo-${res.index}`);
          if (
            photoEl.offsetTop + photoEl.offsetHeight >
            this.scrollContainer.nativeElement.offsetHeight
          ) {
            this.scrollContainer.nativeElement.scrollTo({
              top: photoEl.offsetTop - photoEl.offsetHeight,
              behavior: 'smooth',
            });
          }
        }),
    );
  }

  public close() {
    this._modalController.dismiss();
  }

  public openFullscreen(index: number) {
    this._chatService.openMediaModalByIndex(index).subscribe();
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach((s) => s?.unsubscribe());
  }
}
